import { api } from './config';

const walletApi = api();

// ── Customer: Bank accounts ──────────────────────────────────────────────────
export const getBankList = async () => {
  try {
    const r = await walletApi.get('/wallet/bank-list');
    return r.data;
  } catch (e) {
    throw e.response?.data || { message: e.message };
  }
};

export const getMyBankAccounts = async () => {
  try {
    const r = await walletApi.get('/wallet/bank-accounts');
    return r.data;
  } catch (e) {
    throw e.response?.data || { message: e.message };
  }
};

export const createBankAccount = async (formData) => {
  try {
    const r = await walletApi.post('/wallet/bank-accounts', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return r.data;
  } catch (e) {
    throw e.response?.data || { message: e.message };
  }
};

export const updateBankAccount = async (id, formData) => {
  try {
    const r = await walletApi.put(`/wallet/bank-accounts/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return r.data;
  } catch (e) {
    throw e.response?.data || { message: e.message };
  }
};

export const deleteBankAccount = async (id) => {
  try {
    const r = await walletApi.delete(`/wallet/bank-accounts/${id}`);
    return r.data;
  } catch (e) {
    throw e.response?.data || { message: e.message };
  }
};

// ── Customer: Withdrawals ────────────────────────────────────────────────────
export const getWithdrawalOptions = async () => {
  try {
    const r = await walletApi.get('/wallet/withdrawal/options');
    return r.data;
  } catch (e) {
    throw e.response?.data || { message: e.message };
  }
};

export const getMyWithdrawalRequests = async () => {
  try {
    const r = await walletApi.get('/wallet/withdrawal/my-requests');
    return r.data;
  } catch (e) {
    throw e.response?.data || { message: e.message };
  }
};

export const createWithdrawalRequest = async (sourceCurrency, bankAccountId) => {
  try {
    const r = await walletApi.post('/wallet/withdrawal/request', { sourceCurrency, bankAccountId });
    return r.data;
  } catch (e) {
    throw e.response?.data || { message: e.message };
  }
};

export const cancelWithdrawalRequest = async (id) => {
  try {
    const r = await walletApi.patch(`/wallet/withdrawal/request/${id}/cancel`);
    return r.data;
  } catch (e) {
    throw e.response?.data || { message: e.message };
  }
};

// Cash at a branch (all new withdrawals since 2026-10-20): any amount, collected
// with a 6-digit pickup code at any branch.
export const createCashWithdrawalRequest = async (sourceCurrency, amount, stationId) => {
  try {
    const r = await walletApi.post('/wallet/withdrawal/request', { sourceCurrency, amount, stationId });
    return r.data;
  } catch (e) {
    throw e.response?.data || { message: e.message };
  }
};

// ── Customer: wallet self-activation ────────────────────────────────────────
export const getWalletActivationStatus = async () => {
  try {
    const r = await walletApi.get('/wallet/activation/status');
    return r.data;
  } catch (e) {
    throw e.response?.data || { message: e.message };
  }
};

export const requestWalletActivationOtp = async () => {
  try {
    const r = await walletApi.post('/wallet/activation/otp');
    return r.data;
  } catch (e) {
    throw e.response?.data || { message: e.message };
  }
};

export const activateWallet = async (body) => {
  try {
    const r = await walletApi.post('/wallet/activate', { channel: 'web', ...body });
    return r.data;
  } catch (e) {
    throw e.response?.data || { message: e.message };
  }
};

// ── Staff: Bank account verification ─────────────────────────────────────────
export const adminGetBankAccounts = async (filters = {}) => {
  try {
    const r = await walletApi.get('/wallet/admin/bank-accounts', { params: filters });
    return r.data;
  } catch (e) {
    throw e.response?.data || { message: e.message };
  }
};

export const adminVerifyBankAccount = async (id) => {
  try {
    const r = await walletApi.post(`/wallet/admin/bank-accounts/${id}/verify`);
    return r.data;
  } catch (e) {
    throw e.response?.data || { message: e.message };
  }
};

export const adminRejectBankAccount = async (id, rejectionReason) => {
  try {
    const r = await walletApi.post(`/wallet/admin/bank-accounts/${id}/reject`, { rejectionReason });
    return r.data;
  } catch (e) {
    throw e.response?.data || { message: e.message };
  }
};

// ── Staff: Withdrawal approval ───────────────────────────────────────────────
export const adminGetWithdrawals = async (filters = {}) => {
  try {
    const r = await walletApi.get('/wallet/admin/withdrawal', { params: filters });
    return r.data;
  } catch (e) {
    throw e.response?.data || { message: e.message };
  }
};

export const adminGetWithdrawalDetail = async (id) => {
  try {
    const r = await walletApi.get(`/wallet/admin/withdrawal/${id}`);
    return r.data;
  } catch (e) {
    throw e.response?.data || { message: e.message };
  }
};

export const adminApproveWithdrawal = async (id, approvalNotes) => {
  try {
    const r = await walletApi.post(`/wallet/admin/withdrawal/${id}/approve`, { approvalNotes });
    return r.data;
  } catch (e) {
    throw e.response?.data || { message: e.message };
  }
};

export const adminRejectWithdrawal = async (id, rejectionReason) => {
  try {
    const r = await walletApi.post(`/wallet/admin/withdrawal/${id}/reject`, { rejectionReason });
    return r.data;
  } catch (e) {
    throw e.response?.data || { message: e.message };
  }
};

// ── Staff: cash payout at the counter ────────────────────────────────────────
export const adminGetWithdrawalByCode = async (code) => {
  try {
    const r = await walletApi.get(`/wallet/admin/withdrawal/by-code/${encodeURIComponent(code)}`);
    return r.data;
  } catch (e) {
    throw e.response?.data || { message: e.message };
  }
};

export const adminSendPayoutOtp = async (id) => {
  try {
    const r = await walletApi.post(`/wallet/admin/withdrawal/${id}/send-otp`);
    return r.data;
  } catch (e) {
    throw e.response?.data || { message: e.message };
  }
};

export const adminPayCashWithdrawal = async (id, body) => {
  try {
    const r = await walletApi.post(`/wallet/admin/withdrawal/${id}/pay`, body);
    return r.data;
  } catch (e) {
    throw e.response?.data || { message: e.message };
  }
};

// ── Photo URLs ───────────────────────────────────────────────────────────────
export const getBankPhotoUrl = (filename) => {
  const base = process.env.REACT_APP_BASE_URL || 'http://localhost:5000/api';
  return `${base}/wallet/bank-photo/${filename}`;
};

export default {
  getBankList, getMyBankAccounts, createBankAccount, updateBankAccount, deleteBankAccount,
  getWithdrawalOptions, getMyWithdrawalRequests, createWithdrawalRequest, cancelWithdrawalRequest,
  createCashWithdrawalRequest, getWalletActivationStatus, requestWalletActivationOtp, activateWallet,
  adminGetBankAccounts, adminVerifyBankAccount, adminRejectBankAccount,
  adminGetWithdrawals, adminGetWithdrawalDetail, adminApproveWithdrawal, adminRejectWithdrawal,
  adminGetWithdrawalByCode, adminSendPayoutOtp, adminPayCashWithdrawal,
  getBankPhotoUrl,
};
